module.exports = __webpack_public_path__ + "static/media/Jessica.aa3660d7.png";